export const PREVIEWABLE_EXTENSIONS = [
  '.bmp',
  '.doc',
  '.docx',
  '.jpg',
  '.jpeg',
  '.pdf',
  '.png',
  '.ppt',
  '.pptx',
  '.tiff',
  '.tif',
  '.txt',
  '.xls',
  '.xlsx',
  '.csv',
];
